import { render, staticRenderFns } from "./Artworks.vue?vue&type=template&id=07e49e53&scoped=true"
import script from "./Artworks.vue?vue&type=script&lang=js"
export * from "./Artworks.vue?vue&type=script&lang=js"
import style0 from "./Artworks.vue?vue&type=style&index=0&id=07e49e53&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e49e53",
  null
  
)

export default component.exports